// Error feedback component for Boundary
import { useEffect, useRef } from 'react';
import { Result, Button } from 'antd';
import { useNotification } from '@context/NotificationProvider';

const ErrorFeedback = ({ error, onReload }) => {
    const { showNotification } = useNotification();
    const hasNotified = useRef(false);

    useEffect(() => {
        if (!hasNotified.current) {
            hasNotified.current = true;
            showNotification('error', 'Application Error', error?.message || 'Unknown error', 'Developer', 8);
        }
    }, [showNotification, error]);

    return (
        <Result
            status="error"
            title="Something went wrong"
            subTitle={error?.message || 'An unexpected error occurred.'}
            extra={
                <Button type="primary" onClick={onReload}>
                    Reload
                </Button>
            }
            style={{
                width: '100%',
                height: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '16px',
            }}
        />
    );
};

export default ErrorFeedback;
